import Modal from "../../../../global/components/Modal/Modal.vue";
import PuxButton from "../../../../global/components/PuxButton/PuxButton.vue";
import PuxTranslate from "../../../../global/components/PuxTranslate/PuxTranslate.vue";

import HttpAPI from "../../../../global/compositionAPI/HttpAPI";
import NotificationAPI from "../../../../global/compositionAPI/NotificationAPI";

// @vue/component
import { getTextFromPlaceholder } from "../../../../global/functions/utils";
import {
  forEach,
  toString
} from "lodash-es";

// @vue/component
export default {
  name: "TemplateAdminModalCopy",
  components: {
    Modal,
    PuxButton,
    PuxTranslate,
  },
  props: {
    template: {
      type: Object,
      required: true,
    },
    baseUrl: {
      type: String,
      required: true,
    },
    close: {
      type: Function,
      default: () => {},
    },
    selectorClose: {
      type: String,
      required: true,
    },
  },
  setup() {
    const {
      postHttp,
    } = HttpAPI();

    const {
      addNotification,
    } = NotificationAPI();

    return {
      addNotification,
      postHttp,
    };
  },
  data() {
    return {
      model: {
        tpl_kbez: undefined,
        tpl_bez: undefined,
      },
      loading: false,
      errors: undefined,
      errorsClone: undefined,
      options: {
        showCloseButton: true,
        required: true,
        list: [
          {
            id: "tpl_kbez",
            type: "text",
            label: "_LBL_TEMPLATE_KURZBESCHREIBUNG_",
            required: true,
            view: "v-alt",
          },
          {
            id: "tpl_bez",
            type: "text",
            label: "_LBL_TEMPLATE_BESCHREIBUNG_",
            required: true,
            view: "v-alt",
          }
        ],
      },
    };
  },
  created() {
    this.setModel();
  },
  methods: {
    setModel() {
      this.model.tpl_kbez = `${ this.template.tpl_kbez } ${ getTextFromPlaceholder("_TXT_TEMPLATE_COPY_SUFFIX_") }`;
      this.model.tpl_bez = `${ this.template.tpl_bez } ${ getTextFromPlaceholder("_TXT_TEMPLATE_COPY_SUFFIX_") }`;
    },

    save() {
      this.loading = true;
      const DATA = {};
      forEach(this.model, (item, key) => {
        DATA[key] = toString(item).trim();
      });
      return this.postHttp({
        url: `${ this.baseUrl }kopieren/`,
        data: DATA,
      }).then(
        response => {
          this.addNotification({ text: "_MSG_TEMPLATE_CREATE_COPY_SUCCESS_" });
          this.close();
          this.$goTo("root.templateadmin.details", { id: response.pk });
        },
        errors => {
          this.onError({ error: errors.data });
        },
      ).finally(
        () => this.loading = false,
      );
    },

    onError({ error }) {
      this.errors = error;
      this.errorsClone = error;
    },
  },
};
